import styled from "styled-components";


export const ContainerCheckbox = styled.div`
display: flex;

`;